
import TimeRangeFacet from './TimeRangeFacet.vue';
import DateRangeFacet from './DateRangeFacet.vue';
import DropdownFacet  from './DropdownFacet.vue';
import DropDownGroupedFacet from './DropDownGroupedFacet.vue';
import type { FacetConfig } from '../../../types/facetsTypes';

export const TEAMSCHEDULE_BASE_FACETS: FacetConfig[] = [
    {
        id: 'users', name: 'Users', urlKey: 'usersId__$in', component: DropDownGroupedFacet, needsData: true, visible: true
    },
    {
        id: 'teams', name: 'Teams', urlKey: 'teamName__$in', component: DropDownGroupedFacet, needsData: true, visible: true
    },
    {
        id: 'businessRoles', name: 'Business Role', urlKey: 'businessRole__$in', component: DropdownFacet, needsData: true, visible: true
    },
    {
        id: 'locations', name: 'Location', urlKey: 'location__$in', component: DropdownFacet, needsData: true, visible: true
    },
    {
        id: 'tags', name: 'Tags', urlKey: 'tags.text__$in', component: DropdownFacet, needsData: true, visible: true
    },
    {
        id: 'tasks', name: 'Tasks', urlKey: 'tasks.text__$in', component: DropdownFacet, needsData: true, visible: true
    },
    {
        id: 'tasksStartFacet',
        name: 'Task start between',
        urlKey: 'tasksStartFacet.text__$in',
        component: TimeRangeFacet,
        needsData: false,
        visible: true
    },
    {
        id: 'leaveTasks', name: 'Leave', urlKey: 'leave.text__$in', component: DropdownFacet, needsData: true, visible: true
    },
    {
        id: 'shiftTemplates', name: 'Shift Template', urlKey: 'leave.text__$in', component: DropdownFacet, needsData: true, visible: true
    },
    {
        id: 'shiftStartFacet',
        name: 'Shift start between',
        urlKey: 'leave.text__$in',
        component: TimeRangeFacet,
        needsData: false,
        visible: true
    },
    {
        id: 'shiftLocations', name: 'Shift Location', urlKey: 'leave.text__$in', component: DropdownFacet, needsData: true, visible: true
    },
    {
        id: 'dateFacet', name: 'Date', urlKey: 'date', component: DateRangeFacet, needsData: false, visible: true
    }
];
